// src/components/common/ToastProvider.jsx
import React from "react";
import { Toaster } from "react-hot-toast";

const ToastProvider = () => {
  return (
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 5000,
        style: {
          fontSize: "14px",
          maxWidth: "700px",
        },
      }}
      reverseOrder={false}
    />
  );
};

export default ToastProvider;
